import { render, staticRenderFns } from "./SurveyNextPrevious.vue?vue&type=template&id=e78d6222&scoped=true&"
import script from "./SurveyNextPrevious.vue?vue&type=script&lang=ts&"
export * from "./SurveyNextPrevious.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e78d6222",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
